import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let message = 'An unexpected error occurred';
      if (error.status === 404) {
        message = 'Resource not found (404)';
      } else if (error.status === 502) {
        message = 'Server error (502)';
      }

      router.navigate(['/error'], { queryParams: { message } });
      return throwError(() => error);
    })
  );
};